export default "__VITE_ASSET__DWDy1L7W__"